import * as THREE from "three";

import { ReactElement, useEffect } from "react";

type Props = {
    id: string;
    width: number;
    height: number;
};

export default function GlobeCanvas({
    id,
    width,
    height,
}: Props): ReactElement {
    function animate() {
        cube.rotation.x += 0.01;
        cube.rotation.y += 0.01;

        renderer.render(scene, camera);
    }

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);

    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(width, height);
    renderer.setAnimationLoop(animate);

    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
    const cube = new THREE.Mesh(geometry, material);
    scene.add(cube);

    camera.position.z = 5;

    useEffect(() => {
        const wrapper = document.getElementById(id);
        const domElement = renderer.domElement;

        if (wrapper != null && !wrapper.hasChildNodes()) {
            wrapper.appendChild(domElement);
        }

        return () => {
            wrapper?.removeChild(domElement);
        };
    }, []);

    return <div id={id} />;
}
